import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
// @mui
import { Box, Card, Typography, Stack, Avatar, Tooltip } from "@mui/material";
// routes
import { PATH_PAGE } from "../../../../routes/paths";
// components
import Label from "../../../../components/Label";
import Image from "../../../../components/Image";

import { useState } from "react";

import FullDescriptionDialog from "./FullDescriptionDialog";
import { useDispatch, useSelector } from "react-redux";
import { setServiceDetails } from "src/redux/slices/service";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import StarIcon from "@mui/icons-material/Star";
import { fShortenNumber } from "src/utils/formatNumber";
import CurrencyFormat from "react-currency-format";
import Iconify from "src/components/Iconify";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { selectTemplate } from "src/features/templateSlice";
import useResponsive from "src/hooks/useResponsive";

// ----------------------------------------------------------------------

ShopProductCardServices.propTypes = {
  product: PropTypes.object,
};

const IconifyBoxStyled = styled("div")(() => ({
  border: "1px solid black",
  borderRadius: "10px",
  padding: "5px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

export default function ShopProductCardServices({ product }) {
  const { template } = useSelector(selectTemplate);

  const isDesktop = useResponsive("up", "md");

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const {
    serviceTitle,
    imagesFiles,
    serviceDescription,
    district,
    logoFile,
    nameOfContactPerson,
    totalRating,
    totalReview,

    /**
     * car rental properties
     */
    featuredImage,
    name,
    price,
    serviceCategory,
    passengers,
    luggage,
    doors,
    transmission,
    airConditioning,
  } = product;

  const [openFullDescriptionDialog, setOpenFullDescriptionDialog] =
    useState(false);

  const vehicleOptions = [
    {
      tooltipTitle: "Doors",
      badgeContent: Number(doors || 0),
      icon: "mingcute:car-door-line",
    },
    {
      tooltipTitle: "Seats",
      badgeContent: Number(passengers || 0),
      icon: "mingcute:seat-line",
    },
    {
      tooltipTitle: "Transmission",
      badgeContent: transmission || "",
      icon:
        transmission === "Manual"
          ? "solar:transmission-bold"
          : "tabler:automatic-gearbox-filled",
    },
    {
      tooltipTitle: "Luggage",
      badgeContent: Number(luggage || 0),
      icon: "fluent:luggage-32-regular",
    },
    {
      tooltipTitle: "Air Conditioning",
      badgeContent: airConditioning ? (
        <DoneIcon style={{ fontSize: "10px", paddiing: "1px" }} />
      ) : (
        <CloseIcon />
      ),
      icon: "hugeicons:thermometer-cold",
    },
  ];

  function openServiceDetail() {
    dispatch(setServiceDetails({ ...product }));
    navigate(PATH_PAGE.serviceDetail);
  }

  return (
    <>
      <Card
        sx={{ boxShadow: 10, cursor: "pointer" }}
        onClick={() => openServiceDetail()}
      >
        <Box sx={{ position: "relative" }}>
          <Image
            alt={name || ""}
            src={featuredImage[0]?.downloadURL || ""}
            ratio="16/9"
          />
        </Box>

        <Stack spacing={1} sx={{ p: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{ textTransform: "capitalize", textAlign: "left" }}
          >
            {name || ""}
          </Typography>

          <Typography variant="body2" align="left">
            {product?.serviceCategory?.serviceName || ""}
          </Typography>

          {/* <Typography variant="subtitle1" align="center">
                <CurrencyFormat
                  value={Number(price || 0).toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={
                    template === process.env.REACT_APP_OWNER_CAR_RENTAL_ATISH
                      ? process.env.REACT_APP_CURRENCY_USED
                      : "Rs "
                  }
                />{" "}
                / day
              </Typography> */}

          <Typography variant="subtitle2" align="left">
            {/* <span style={{ fontWeight: "normal" }}>Short term:</span>{" "} */}
            {/*  {` ${product?.priceShortTerm || ""}`} */}
            Short term:{" "}
            <span style={{ fontWeight: "normal" }}>
              {product?.priceShortTerm || ""}
            </span>
          </Typography>

          <Typography variant="subtitle2" align="left">
            {/* <span style={{ fontWeight: "normal" }}>Short term:</span>{" "} */}
            {/*  {` ${product?.priceShortTerm || ""}`} */}
            Long term:{" "}
            <span style={{ fontWeight: "normal" }}>
              {product?.priceLongTerm || ""}
            </span>
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent={"center"}
            spacing={1}
            sx={{ mb: 2 }}
          >
            {vehicleOptions &&
              vehicleOptions?.map((option) => (
                <Tooltip
                  title={`${option?.tooltipTitle || ""}: ${
                    option?.badgeContent
                  }`}
                >
                  <IconifyBoxStyled>
                    <Iconify
                      icon={option?.icon}
                      width={isDesktop ? 25 : 13}
                      height={isDesktop ? 25 : 13}
                    />
                  </IconifyBoxStyled>
                </Tooltip>
              ))}
          </Stack>

          {/* <Stack
                direction="row"
                alignItems="center"
                justifyContent={"center"}
                spacing={1}
                sx={{ mb: 2 }}
              >
                <StarIcon color="warning" />
                {Number(totalRating || 0).toFixed(1)}
                {totalReview ? (
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    ({fShortenNumber(totalReview || 0)}
                    reviews)
                  </Typography>
                ) : (
                  <></>
                )}
              </Stack> */}
        </Stack>
      </Card>
    </>
  );
}
